import { useCallback } from 'react'
import { Container, ContainerActions, ImagePreview } from './styles'

interface UploadProps {
  file: File
  handleRemoveFile?: (file: File) => void
}

const TYPES_IMAGES = ['png', 'jpg', 'jpeg']

export const Upload = ({ file, handleRemoveFile }: UploadProps) => {
  const handleDownload = useCallback(() => {
    const blobURL = URL.createObjectURL(file)
    const a = document.createElement('a')
    a.href = blobURL
    a.download = file.name
    document.body.appendChild(a)
    a.click()
  }, [file])

  return (
    <Container>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center'
        }}
      >
        {TYPES_IMAGES.some(ext => file?.name.includes(ext)) ? (
          <ImagePreview>
            <img src={URL.createObjectURL(file)} alt={file.name} />
          </ImagePreview>
        ) : (
          <span className="form-label fw-bold fs-6 mt-2">{file.name}</span>
        )}

        <span
          style={{
            maxWidth: '250px',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap'
          }}
          className="form-label fw-bold fs-6 mt-2"
        >
          {file.name}
        </span>
      </div>

      <ContainerActions>
        <button
          type="button"
          className="btn btn-primary me-5"
          onClick={handleDownload}
        >
          Baixar
        </button>
        {!!handleRemoveFile && (
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => handleRemoveFile?.(file)}
          >
            Excluir
          </button>
        )}
      </ContainerActions>
    </Container>
  )
}
